(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});
  var FORCE_ANIMATED_MOTION = true; 
  var scrollReadyCallbacks = [];
  var isScrollReady = false;

  DNB.ScrollService = {
    lenis: null,
    locked: false,

    init: function () {
      if (this.lenis) return;
       
      var Lenis = window.Lenis;
      if (!Lenis) return;

      this.lenis = new Lenis({
        duration: 1.1,
        easing: function (t) {
          return Math.min(1, 1.001 - Math.pow(2, -10 * t));
        },
        smoothWheel: true,
        touchMultiplier: 1.2
      });

      document.documentElement.classList.add("has-smooth-scroll");

      var self = this;
      function raf(time) {
        self.lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);

      if (window.gsap && window.ScrollTrigger) {
        this.lenis.on("scroll", ScrollTrigger.update);
        ScrollTrigger.scrollerProxy(document.documentElement, {
          scrollTop: function (value) {
            if (arguments.length) {
              self.lenis.scrollTo(value, { immediate: true });
            }
            return self.lenis.scroll;
          },
          getBoundingClientRect: function () {
            return {
              top: 0,
              left: 0,
              width: window.innerWidth,
              height: window.innerHeight
            };
          }
        });
        ScrollTrigger.addEventListener("refresh", function () {
          self.lenis.resize();
        });
      }

      isScrollReady = true;
      scrollReadyCallbacks.forEach(function (cb) {
        try {
          cb();
        } catch (e) {
          console.error(e);
        }
      });
      scrollReadyCallbacks = [];
    },

    onScrollReady: function (callback) {
      if (typeof callback !== "function") return;
      if (isScrollReady) {
        callback();
      } else {
        scrollReadyCallbacks.push(callback);
      }
    },

    scrollTo: function (target, options) {
      if (!this.lenis) {
        if (typeof target === "number") {
          window.scrollTo({ top: target, behavior: "smooth" });
        } else if (target && target.getBoundingClientRect) {
          target.scrollIntoView({ behavior: "smooth" });
        }
        return;
      }
      this.lenis.scrollTo(target, options || {});
    },

    lock: function () {
      if (this.locked || !this.lenis) return;
      this.locked = true;
      this.lenis.stop();
    },

    unlock: function () {
      if (!this.locked || !this.lenis) return;
      this.locked = false;
      this.lenis.start();
    },

    refresh: function (hard) {
      if (window.ScrollTrigger) {
        ScrollTrigger.refresh(hard);
      }
      if (this.lenis) {
        this.lenis.resize();
      }
    }
  };

  DNB.onScrollReady = DNB.ScrollService.onScrollReady.bind(DNB.ScrollService);
  DNB.prefersReducedMotion = function () {
    return !FORCE_ANIMATED_MOTION && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  };

  // Ortak güvenli init — tüm bundle init dosyaları bunu kullanır. Bir modül
  // yoksa/patlarsa diğerlerine geçişi bozmaz (section'lar CMS ile açılıp kapanır).
  DNB.safeInit = function (name, fn) {
    // Modül bu bundle'a dahil değilse (DNB[name] yok) sessizce atla.
    // Böylece init listesine yazılıp o sayfanın bundle'ında bulunmayan bir
    // modül hata üretmez; modül varsa kendi kök element guard'ı devreye girer.
    var mod = DNB[name];
    if (!mod || typeof mod.init !== "function") {
      return;
    }
    try {
      fn();
    } catch (err) {
      console.error("[DNB] " + name + " init failed:", err);
    }
  };

  DNB.extractYoutubeId = function (raw) {
    if (!raw) return "";
    raw = String(raw).trim();
    if (/^[\w-]{11}$/.test(raw)) return raw;
    var match = raw.match(
      /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/i
    );
    return match ? match[1] : raw;
  };

  DNB.buildYoutubeEmbedUrl = function (idOrUrl, options) {
    var id = DNB.extractYoutubeId(idOrUrl);
    if (!id) return "";

    options = options || {};
    var params = [
      "autoplay=" + (options.autoplay === false ? "0" : "1"),
      "mute=" + (options.mute === false ? "0" : "1"),
      "enablejsapi=1",
      "rel=0",
      "playsinline=1"
    ];

    return "https://www.youtube.com/embed/" + encodeURIComponent(id) + "?" + params.join("&");
  };
})(window, document);
